export default "__VITE_ASSET__BNaEgohr__"